import ParticularLayout from "../layouts/particular-layout";
import DetailsQcm from "../pages/Apprenants/Testing/Qcms/DetailsQcm";
import ResultQcm from "../pages/Apprenants/Testing/ResultQcm";
import QCMComponent from "../pages/Apprenants/Testing/Qcms/QCMComponent";
import TestReviewResponse from "../pages/Apprenants/Testing/TestReviewResponse";
import TestResults from "../pages/Apprenants/Testing/TestResults";
import InvitationList from "../pages/Apprenants/Testing/InvitationList";
import InvitationDetails from "../pages/Apprenants/Testing/InvitationDetails";
import ProgramList from "../pages/Apprenants/Support/Programme/ProgramList";
import ProgramDetail from "../pages/Apprenants/Support/Programme/ProgramDetail";
import QcmIndexEmp from "../pages/Apprenants/Testing/QcmIndexEmp";
import { FolderAppr } from "../pages/Apprenants/Photo/folder-appr";
import { ProjectAppr } from "../pages/Apprenants/Photo/project-appr";
import { CrudImageAppr } from "../pages/Apprenants/Photo/crud-image-appr";
import LayoutCalendarApprenant from "../layouts/apprenants/LayoutCalendarApprenant";
import SemaineCalendarApprenant from "../pages/Apprenants/agenda/semaines/SemaineCalendarApprenant";
import AnnuelCalendarApprenant from "../pages/Apprenants/agenda/annuels/AnnuelCalendarApprenant";
import { AttendanceProject } from "../pages/Apprenants/Presence/attendance-project";
import GamificationPage from "../pages/Apprenants/Gamification/gamification-page";
import PageProjets from "../pages/Apprenants/Projet/projet";
import Refresh from "../pages/Apprenants/Refresh/Refresh";
import ModuleApprenant from "../pages/Apprenants/Refresh/Module";
import { AttendanceContent } from "../contents/attendance-content";
import { PhotoContent } from "../contents/photoContent";
import { AuthCalendarProvider } from "../contexts/AuthCalendarProvider";
import { SupportContent } from "../contents/support-content";
import HomePageApp from "../pages/Apprenants/home";
import { ProjectApprenticeList } from "../pages/Apprenants/evaluationChaud/pages/ProjectApprenticeList";
import ProjectDetails from "../pages/Apprenants/evaluationChaud/pages/ProjectDetails";
// import { ContextProvider } from '../pages/Apprenants/evaluationChaud/components/Context/ContextProvider';
import { EvaluationList } from "../pages/Apprenants/EvalFroid/EvaluationList";
import ProjetParticularDetail from "../pages/Apprenants/Projet/detail";
import { SearchProviderProject } from "../contexts/cfp/SearchContextProject";
import { TestingContentEmp } from "../contents/testing-content-emp";
import SkillApprenantContent from "../contents/skill-apprenant";
import { Navigate } from "react-router-dom";
import ApprProjectList from "../pages/Apprenants/skill_matrix/ApprProjectList";
import ApprSkills from "../pages/Apprenants/skill_matrix/ApprSkills";
import { EditProfile } from "../pages/Apprenants/Profil";
import { ProjectInProgress } from "../pages/Apprenants/Projet/in-progress";
import { ProjectCanceled } from "../pages/Apprenants/Projet/canceled";
import { ProjectFinished } from "../pages/Apprenants/Projet/finished";
import { ProjectInPreparation } from "../pages/Apprenants/Projet/in_preparation";
import { ProjectPlanned } from "../pages/Apprenants/Projet/planned";
import { ProjectCloed } from "../pages/Apprenants/Projet/closed";
import { ProjectFenced } from "../pages/Apprenants/Projet/fenced";
import { ModuleProvider } from "../contexts/ModuleContext";
import RefreshLayoutApprenant from "../layouts/apprenants/refresh-layout-apprenant";

const particularRoutes = {
  path: "/particulier",
  element: <ParticularLayout />,
  children: [
    {
      index: true,
      element: <HomePageApp />,
    },
    {
      path: "presence",
      // path: "presence",
      element: <AttendanceContent />,
      children: [
        {
          index: true,
          element: <AttendanceProject />,
        },
      ],
    },
    {
      path: "support",
      element: <SupportContent />,
      children: [
        {
          index: true,
          element: <ProgramList />,
        },
        {
          path: "programmes/:id",
          element: <ProgramDetail />,
        },
      ],
    },
    {
      path: "profile",
      element: <EditProfile />,
    },
    {
      path: "photo",
      element: <PhotoContent />,
      children: [
        {
          index: true,
          element: <FolderAppr />,
        },
        {
          path: "projets",
          element: <ProjectAppr />,
        },
        {
          path: "ajout",
          element: <CrudImageAppr />,
        },
      ],
    },
    {
      path: "test",
      element: <TestingContentEmp />,
      children: [
        {
          index: true,
          element: <QcmIndexEmp />,
        },
        {
          path: "qcm/show/:id",
          element: <DetailsQcm />,
        },
        {
          path: "qcm/:id/list-apprenants/results",
          element: <ResultQcm />,
        },
        {
          path: "qcm/solve/:id/respond",
          element: <QCMComponent />,
        },
        {
          path: "qcm/solve/:id/review",
          element: <TestReviewResponse />,
        },
        {
          path: "qcm/solve/:id/results",
          element: <TestResults />,
        },
        {
          path: "qcm/invitations-index",
          element: <InvitationList />,
        },
        {
          path: "qcm/invitations/:id",
          element: <InvitationDetails />,
        },
      ],
    },
    {
      path: "gamification",
      element: <GamificationPage />,
    },
    //projet
    {
      path: "projet",
      element: <SearchProviderProject />,
      children: [
        {
          index: true,
          element: <PageProjets />,
        },
        { path: "detail/:id", element: <ProjetParticularDetail /> },
        { path: "termine", element: <ProjectFinished /> },
        { path: "annule", element: <ProjectCanceled /> },
        { path: "en_cours", element: <ProjectInProgress /> },
        { path: "preparation", element: <ProjectInPreparation /> },
        { path: "planifie", element: <ProjectPlanned /> },
        { path: "cloture", element: <ProjectCloed /> },
        { path: "reporte", element: <ProjectFenced /> },
      ],
    },
    {
      path: "/particulier/refresh",
      element: (
        <ModuleProvider>
          {" "}
          <RefreshLayoutApprenant />{" "}
        </ModuleProvider>
      ),
      children: [
        {
          index: true,
          // element: <Navigate to="module" />,
          element: <ModuleApprenant />,
        },
      ],
    },
    {
      path: "agenda",
      element: <AuthCalendarProvider />,
      children: [
        {
          element: <LayoutCalendarApprenant />,
          children: [
            {
              index: true,
              element: <AnnuelCalendarApprenant />,
            },
            {
              path: "annuel",
              element: <AnnuelCalendarApprenant />,
            },
            {
              path: "semaine",
              element: <SemaineCalendarApprenant />,
            },
          ],
        },
      ],
    },
    //evaluation
    {
      path: "evaluations/chaud",
      element: <ProjectApprenticeList />,
    },
    {
      path: "evaluations/projetsEmp/:idProjet/detailEmp",
      element: <ProjectDetails />,
    },
    {
      path: "evaluations/froid",
      element: <EvaluationList />,
    },
    {
      path: "skill_matrix",
      element: <SkillApprenantContent />,
      children: [
        {
          index: true,
          element: <Navigate to="projets" />,
        },
        {
          path: "projets",
          element: <ApprProjectList />,
        },
        {
          path: "projets/:idProjet",
          element: <ApprSkills />,
        },
      ],
    },
  ],
};

export default particularRoutes;
